import { Component, OnInit } from '@angular/core';
import { EventsService } from '../_services/events.service';
import { TabledataService } from '../_services/tabledata.service';
import { LayersService } from '../_services/layers.service';
import { SearchService } from '../search/search.service'
import { Mapapi } from './mapapi';
import { MeasureTool } from './measure-tool';
import { AfterViewInit } from '@angular/core';
import Point from 'ol/geom/Point';
import Feature from 'ol/Feature';
import { fromLonLat } from 'ol/proj';
import { transform } from 'ol/proj';
import { GlobalsService } from '../_services/globals.service';

@Component({
    selector: 'app-ol-map',
    templateUrl: './ol-map.component.html',
    styleUrls: ['./ol-map.component.css'],
    standalone: false
})
export class OlMapComponent implements OnInit, AfterViewInit {

    mt: MeasureTool;
    selectedmeasure: any = 0;
    areaToolEnabled = false;
    lengthToolEnabled = false;
    panToolEnabled = false;
    map: string = "mymap";
    maptype: string = "NORMAL";
    measureoptions: any[] = [{ label: 'Površina', value: 1 }, { label: 'Dolžina', value: 2 }, { label: 'Premik', value: 0 }];




    constructor(
        private es: EventsService,
        private api: Mapapi,
        private tabledataService: TabledataService,
        private ss: SearchService,
        private ls: LayersService,
        private gs: GlobalsService
    ) {
    }

    private addLayer(node): void {
        // PAZI NOV MODUL: sistemi daljinskega ogrevanja --> RRI
        if (node?.data?.id === 'district-heating-lines' || node?.data?.id === 'district-heating-houses') {
            const layer = this.api.getLayerById(node.data.id);
            if (layer) {
                layer.setVisible(true);
            }
            return;
        }

        if (!this.api.layerExists(node.data.id)) {
            var areafilter: string = null;
            var cqlexp: string = null;

            if (node.data.cql) {
                for (let cq of node.data.cql) {
                    if (cq.runonstart)
                        cqlexp = cq.val;
                }
            }

            if (node.data.areafilter) {
                if (cqlexp !== null)
                    cqlexp = cqlexp + " and " + node.data.areafilter;
                else
                    cqlexp = node.data.areafilter;
            }

            var info = true;
            if (node.data.info === undefined || !node.data.info) {
                info = false;
            }
            var select = true;
            if (node.data.select !== undefined && !node.data.select) {
                select = false;
            }

            if (node.data.type === "wfs")
                this.api.createWfsLayer(node.data.url, node.data.layer, node.data.id, cqlexp, info, select);
            else if (node.data.type === "wms")
                this.api.createTileWMSLayer(node.data.url, node.data.layer, node.data.id, cqlexp, info, select);
        }
        else {
            this.api.showLayerById(node.data.id, true);
        }
    }



    private loadCustomTableData(node): void {

        var self = this;
        var data = [];
        var fields = [];
        //console.log("table name  ="+node.label);
        //console.log("custom data load json ! is aditional ="+node.data.additionalData);

        if (node.data.additionalData !== undefined) {

            console.log('node =', node);
            console.log('additionalData =', node?.data?.additionalData);
            console.log('URL =', node?.data?.additionalData?.url);

            this.tabledataService.setOnBeginDownloadData("table");
            this.tabledataService.getData(node.data.additionalData.url, true).subscribe((d: any) => {
                if (d.length > 0) {
                    let keys = Object.keys(d[0]);
                    for (let k in keys) {
                        var hidden: boolean = (keys[k].charAt(0) === "_");
                        fields.push({ field: keys[k], header: keys[k], hidden: hidden });
                    }

                    for (let v of d) {
                        data.push(v);
                    }

                    let label = node.data.additionalData.title.replace(new RegExp('_', 'g'), ' ');
                    this.tabledataService.setOnDoneDownloadData(data);
                    this.tabledataService.setTableData({ data: data, fields: fields, selectedItem: null, id: node.data.id, visible: node.data.tableOn, label: label, node: node, iSadditionalData: true });
                    node.data.additionalData.tabledataloaded = true;
                }

            });

        }
    }


    private isMolCql(cqlfilter: any): boolean {
        return String(cqlfilter ?? '').includes('11027849');
    }

    private loadTableDataWFS_WMS(node): void {
        console.log("LOAD TABLE DATA WFS_WMS", node)
        //console.log("wms load geojson :"+node.data.url);
        //console.log(node);
        if (node.data.showtable === undefined || !node.data.showtable || node.data.tabledataloaded) {
            return;
        }


        var self = this;
        var l = self.api.getLayerById(node.data.id);
        var s = l.getSource();


        if (node.data.type === "wms")//wms
        {
            var cqlfilter = node.data.areafilter;
            if (node.data.cqlsetFilter !== undefined) {
                cqlfilter = node.data.cqlsetFilter;

            }
            //console.log("cql  loadTableDataWFS_WMS :"+cqlfilter);
            let layerName = node.data.layer;
            let layerId = node.data.id;
            let effectiveCqlFilter = cqlfilter;

            if (
                Number(node.data.id) === Number(this.gs.getJavneStavbeLayerId()) &&
                this.isMolCql(cqlfilter)
            ) {
                layerName = 'elek:javna_stavba_mol_agg_v';
                layerId = this.gs.getJavneStavbeMolLayerId();

                effectiveCqlFilter = null;

                console.warn('MOL JAVNE STAVBE: using MOL layer', {
                    originalLayer: node.data.layer,
                    layerName,
                    originalId: node.data.id,
                    layerId,
                    originalCqlFilter: cqlfilter,
                    effectiveCqlFilter
                });
            }

            node.csvurl = self.ls.getGeoJsonWithCql(node.data.url, layerName, effectiveCqlFilter);
            console.warn("WMS URL", node.csvurl)
            this.tabledataService.setOnBeginDownloadData("table");
            self.tabledataService.getData(node.csvurl).subscribe(r => {

                
                var s = self.api.geojson2FeatureSource(r);

                var to = self.api.parseTableDataWFS_WMS(s, layerId);

                if (to.data.length > 0) {
                    self.tabledataService.setTableData({ data: to.data, fields: to.fields, selectedItem: null, id: layerId, visible: node.data.tableOn, label: node.label, node: node, iSadditionalData: false });
                    node.data.tabledataloaded = true;
                }
            },
                err => { console.log(err) },
                () => { this.tabledataService.setOnDoneDownloadData(null); }
            );
        }
        if (node.data.type === "wfs") {
            s.on("change", function () //wfs
            {
                if (typeof s.getFeatures === "function" && s.getFeatures().length > 0) {
                    if (s.getState() === "ready") {


                        var to = self.api.parseTableDataWFS_WMS(s, node.data.id);
                        if (to.data.length > 0) {

                            self.tabledataService.setTableData({ data: to.data, fields: to.fields, selectedItem: null, id: node.data.id, visible: node.data.tableOn, label: node.label, node: node, iSadditionalData: false });
                            node.data.tabledataloaded = true;
                        }

                    }
                }
            });
        }

    }



    public mapSelect(w: string): void {
        this.maptype = w;
        this.api.setMapType(w);


    }


    public toolSelect(event): void {
        let o = event.value;
        if (o == 1) {
            this.mt.enable("area");
            this.areaToolEnabled = !this.areaToolEnabled;
            if (!this.areaToolEnabled) {
                this.api.disableMapCick(false);
                this.mt.disable();
                this.panToolEnabled = true;
            }
            else {
                this.lengthToolEnabled = false;
                this.panToolEnabled = false;
                this.api.disableMapCick(true);
            }

        }
        else if (o == 2) {
            this.mt.enable("length");
            this.lengthToolEnabled = !this.lengthToolEnabled;
            if (!this.lengthToolEnabled) {
                this.api.disableMapCick(false);
                this.mt.disable();
                this.panToolEnabled = true;
            }
            else {
                this.areaToolEnabled = false;
                this.panToolEnabled = false;
                this.api.disableMapCick(true);
            }

        }
        else {
            this.mt.disable();
            this.areaToolEnabled = false;
            this.lengthToolEnabled = false;
            this.panToolEnabled = true;
            this.api.disableMapCick(false);
        }

    }




    ngAfterViewInit() {
        //console.log("create map api:"+this.map);
        this.api.createMap(this.map);

        this.mt = new MeasureTool(this.api.map);
        this.selectedmeasure = 0;
        var event = { value: 3 };
        this.toolSelect(event);

        this.es.subscribeMidChangeEvtListener().subscribe
            (
                f => {
                    this.api.fit(this.api.wkt2Feature(f.wkt_extent).getGeometry().getExtent());
                    this.api.removeAllLayers();

                },
                e => {
                    console.log(e)
                });
        this.api.setMapLoadDone();
    }


    ngOnInit() {


        this.tabledataService.subscribeRequestTableData().subscribe(node => {

            //console.log("got request for table:"+node.label + " show table = "+node.data.showtable);
            this.loadTableDataWFS_WMS(node);
            this.loadCustomTableData(node);

        });


        this.ss.subscribeSelectedResultListener().subscribe(data => {
            if (data?.lon == null || data?.lat == null) {
                return;
            }

            const viewProj = this.api.map.getView().getProjection();
            const coords = transform([data.lon, data.lat], 'EPSG:4326', viewProj);

            const f = new Feature({
                geometry: new Point(coords)
            });

            f.setProperties({ ...data });

            if (data.id != null) {
                f.setId(data.id);
                const layer = this.api.getLayerById(data.id);
                if (layer) {
                    this.api.unselectFeatureForLayer(layer);
                }
            }

            this.api.map.getView().animate({
                center: coords,
                zoom: 18,
                duration: 500
            });

            this.api.selectFeature(f);
        });

        this.tabledataService.subscribeTableRowSelectionListener().subscribe(data => {

            if (data.geometry !== undefined) {
                //console.log("subscribeTableRowSelectionListener");
                //console.log(data);
                //console.log("row selection recived:");
                //this.api.selectInteractionTable.getFeatures().clear();

                this.api.unselectFeatureForLayer(this.api.getLayerById(data.layerID));
                //this.api.selectInteractionTable.getFeatures().push(data.geometry);
                // this.api.map.getView().fit(data.geometry.getGeometry(), this.api.map.getSize());
                // this.api.map.getView().setZoom(10);
                this.api.selectFeature(data.geometry);
            }

        });

        this.tabledataService.subscribeTableRowUnSelectionListener().subscribe(data => {

            //console.log("subscribeTableRowUnSelectionListener");
            //console.log(data);
            //this.api.selectInteractionTable.getFeatures().clear();
            this.api.unselectFeatureByFtId(data.ftID);

        });

        this.es.subscribeNodeSelectListener().subscribe(node => {
            //console.log("add layer !");
            this.addLayer(node);
            //this.loadTableDataWFS_WMS(node);
            //this.loadCustomTableData(node);



        }, err => { console.log(err) });


        this.es.subscribeNodeUnSelectListener().subscribe(node => {
            // PAZI NOV MODUL: sistemi daljinskega ogrevanja --> RRI
            const isDistrictHeating =
                node?.data?.id === 'district-heating-lines' || node?.data?.id === 'district-heating-houses';

            if (isDistrictHeating) {
                return;
            }

            this.api.showLayerById(node.data.id, false);
            this.api.unselectFeatureForLayer(this.api.getLayerById(node.data.id));
        });

        this.es.subscribeNodeListSelectionListener().subscribe(nodes => {
            var self = this;
            this.tabledataService.setTableData([]);
            nodes.forEach(function (node) {
                self.addLayer(node);
            });
            if (nodes.length === 0) {
                self.api.hideAllLayers();
            }
        });

        this.es.subscribeTreeNodeOnOffEvtListener().subscribe((data: any) => {
            // PAZI NOV MODUL: sistemi daljinskega ogrevanja --> RRI
            const isDistrictHeating =
                data?.id === 'district-heating-lines' || data?.id === 'district-heating-houses';

            if (isDistrictHeating) {
                const linesLayer = this.api.getLayerById('district-heating-lines');
                const housesLayer = this.api.getLayerById('district-heating-houses');

                const visible = !!data.ison;

                [linesLayer, housesLayer].forEach(layer => {
                    if (layer) {
                        layer.setVisible(visible);

                        if (!visible) {
                            this.api.unselectFeatureForLayer(layer);
                        }
                    }
                });

                return;
            }
        });
    }
}